module.exports = __webpack_public_path__ + "img/header-engagementRingsDainty@2x.bc93ffe.jpg";